import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"
import { verificarSeTokenEstaExpirado } from "@/middlewares/refresh/refresh.middle"

import { cancelamento } from "@/http/cancelar/cancelar.services"
import { adaptarMensagemErros, STATUS_ERROS } from "@/repositorios/erros"
import { ResultadoApiGET, ResultadoAutenticacaoAPI } from "@/types/api"

/* eslint-disable */
declare module "axios" {
  interface AxiosResponse<T = any> extends Promise<T> { }
}
/* eslint-enable */

export interface OpcoesRepositorioBase {
  utilizaCache?: boolean
  baseUrl?: string
}

export abstract class HttpCliente {
  protected readonly instance: AxiosInstance
  protected cabecalhos: any

  public constructor(baseURL: string) {
    // const BASE_URL_LOCAL = process.env.VUE_APP_BACKEND_BASE_URL_LOCAL; somente quando for fazer teste com api local
    const BASE_URL = baseURL || process.env.VUE_APP_BACKEND_BASE_URL
    this.instance = axios.create({
      baseURL: BASE_URL,
    })

    this._inicializarInterceptadorDeRespostas()
  }

  protected _inicializarInterceptadorDeRespostas = () => {
    this.instance.interceptors.response.use(
      this._manipularResposta,
      this._manipularError
    )
  }

  protected _adicionarTokensParaCancelamento = (config: AxiosRequestConfig) => {
    const fonte = axios.CancelToken.source()

    config.headers = config.headers ?? {}
    config.cancelToken = fonte.token
    cancelamento.adicionarToken(fonte, config.url)

    return config
  }

  private _manipularResposta = (
    resp: AxiosResponse<ResultadoApiGET | ResultadoAutenticacaoAPI>
  ) => {
    this.cabecalhos = resp.headers

    return resp.data
  }

  protected _manipularError = async (error: any) => {
    const erroInterno = error.message && error.message === "Network Error"
    const requisicaoCanceladaPeloUsuario = error.message === "cancelado"
    const respostaEmBlob = error.response?.data instanceof Blob
    let status: string | number

    if (requisicaoCanceladaPeloUsuario) {
      status = "cancelado"
    } else if (erroInterno) {
      status = 500
    } else {
      status = error.response.status
    }

    if (status === STATUS_ERROS.naoAutorizado) {
      try {
        return await verificarSeTokenEstaExpirado(error, this.instance)
      } catch (erroRenovacao) {
        error = erroRenovacao
      }
    }

    if (
      error?.response &&
      respostaEmBlob &&
      status === STATUS_ERROS.malFormado
    ) {
      error.response.data = JSON.parse(await error?.response?.data?.text())
    }

    error = adaptarMensagemErros(error, status)

    return Promise.reject(error)
  }
}
